module.exports = __webpack_public_path__ + "assets/img/37_1593_big.bfa317bf.jpg";